import {useOverlay} from '@nuxt/ui/composables/useOverlay'
import CsvImportModal from '@/csv-transaction-importer/CsvImportModal.vue'

export const usePasteHandler = () => {
    const overlay = useOverlay()
    return (event: ClipboardEvent) => {
        const modal = overlay.create(CsvImportModal)
        const clipboardData = event?.clipboardData?.getData('text/plain')
        modal.open({
            data: clipboardData
        })
    }
}